import Super from 'client-portal/routes/-request/clinician-search';

export default class SiteRequestClinicianSearch extends Super {}
